/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Add_XInputs */

const en_link_editor_add_x = /** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add X`)
};

const es_link_editor_add_x = /** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir X`)
};

const fr_link_editor_add_x = /** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter X`)
};

const de_link_editor_add_x = /** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X hinzufügen`)
};

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const ja_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const zh_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const ar_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const id_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const it_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const ru_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const pt_link_editor_add_x = en_link_editor_add_x;

/** @type {(inputs: Link_Editor_Add_XInputs) => LocalizedString} */
const ko_link_editor_add_x = en_link_editor_add_x;

/**
* | output |
* | --- |
* | "Add X" |
*
* @param {Link_Editor_Add_XInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_add_x = /** @type {((inputs?: Link_Editor_Add_XInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Add_XInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_add_x(inputs)
	if (locale === "es") return es_link_editor_add_x(inputs)
	if (locale === "fr") return fr_link_editor_add_x(inputs)
	if (locale === "de") return de_link_editor_add_x(inputs)
	if (locale === "ja") return ja_link_editor_add_x(inputs)
	if (locale === "zh") return zh_link_editor_add_x(inputs)
	if (locale === "ar") return ar_link_editor_add_x(inputs)
	if (locale === "id") return id_link_editor_add_x(inputs)
	if (locale === "it") return it_link_editor_add_x(inputs)
	if (locale === "ru") return ru_link_editor_add_x(inputs)
	if (locale === "pt") return pt_link_editor_add_x(inputs)
	return ko_link_editor_add_x(inputs)
});